import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MlPrediction, MlPredictionCreate, MlPredictionFilter } from '../data/mlPrediction';

export function createMlPredictionService(client: AxiosInstance) {
  return createCrudService<MlPrediction, MlPredictionCreate, MlPredictionFilter>(
    client,
    '/ai/MlPrediction',
    'id',
  );
}

export type MlPredictionService = CrudService<MlPrediction, MlPredictionCreate, MlPredictionFilter>;
